import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Property } from '@/types/property';
import { useState } from 'react';

interface PropertyDescriptionProps {
  property: Property;
}

export default function PropertyDescription({ property }: PropertyDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Don't render the card if there's no description
  if (!property.client_remarks || property.client_remarks.trim().length === 0) {
    return null;
  }

  const description = property.client_remarks;
  const isLongDescription = description.length > 300;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Property Description</CardTitle>
      </CardHeader>
      <CardContent>
        {isLongDescription ? (
          <>
            <div className="relative">
              <p className={`${!isExpanded ? "line-clamp-5" : ""} text-base`}>
                {description}
              </p>
              {!isExpanded && (
                <div className="absolute bottom-0 left-0 right-0 h-12 bg-linear-to-t from-background to-transparent" />
              )}
            </div>
            <Button
              variant="ghost"
              className="mt-2"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? "Show Less" : "Show More"}
            </Button>
          </>
        ) : (
          <p className="text-base">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}